import {
  INSCRIPTION_CREE_REQUETTE,
  INSCRIPTION_CREE_SUCCES,
  INSCRIPTION_CREE_ECHEC,
  INSCRIPTION_LISTE_ECHEC,
  INSCRIPTION_LISTE_SUCCES,
  INSCRIPTION_LISTE_REQUETTE,
  INSCRIPTION_CREE_RESET,
} from "../constantes/inscriptionConstantes";
import axios from "axios";

//const uri = `http://${manifest.debuggerHost.split(":").shift()}:5000`;
//const uri = `https://ecreal.herokuapp.com`;
//const uri = `https://ecreal.onrender.com`;
//const uri = `https://ahmed.prod-manager.tk/back`;
//const uri = `http://ahmed.prod-manager.tk:5000`;
//const uri = `https://gestpro.globalsystempro.com/back`;

//const uri = `http://192.168.1.21:5000`;

import { store } from "../store";

let uri = "";
function changeURi() {
  const cliServ = store.getState().cliServState.cliServ;
  return (uri =
    cliServ.length != 0
      ? cliServ == "SERV1"
        ? process.env.REACT_APP_SERV_1
        : process.env.REACT_APP_SERV_2
      : process.env.REACT_APP_SERV_1);
}
changeURi();

//

export const listeInsc = () => async (dispatch, getState) => {
  dispatch({ type: INSCRIPTION_LISTE_REQUETTE });

  try {
    const { data } = await axios.get(`${uri}/api/inscription`);
    dispatch({ type: INSCRIPTION_LISTE_SUCCES, payload: data });
  } catch (error) {
    error.response && alert(error.response.data.message);

    dispatch({
      type: INSCRIPTION_LISTE_ECHEC,
      payload: error.response && error.response.data.message,
    });
  }
};

export const creeInscription = (insc) => async (dispatch) => {
  try {
    dispatch({ type: INSCRIPTION_CREE_REQUETTE });

    const config = {
      headers: {
        "content-type": "application/json",
      },
    };
    const { data } = await axios.post(`${uri}/api/inscription`, insc, config);
    alert("Inscription est enregistree avec succes!");
    dispatch({ type: INSCRIPTION_CREE_SUCCES, payload: data });
    dispatch({ type: INSCRIPTION_CREE_RESET });
  } catch (error) {
    //  error.response && alert(error.response.data.message);
    dispatch({
      type: INSCRIPTION_CREE_ECHEC,
      payload: error.response && error.response.data.message,
    });
  }
};
